import { Snackbar } from "@mui/material"
import { TestingInfoBlock } from "./TestingInfo"
import { useState } from "react"
import { format } from "date-fns"

const getTimestamp = (): string => format(new Date(), 'dd-MMM-yyyy HH:mm:ss')

const TimestampSnackbar: React.FC = () => {
  const [timestamp, setTimestamp] = useState(getTimestamp())

  setTimeout(() => {
    setTimestamp(getTimestamp())
  }, 1000)

  return (
    <Snackbar
      open={true}
      message={`Timestamp: ${timestamp}`}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    />
  )
}

export const TestingTimestampSnackbar: React.FC = () =>
  <TestingInfoBlock>
    <TimestampSnackbar />
  </TestingInfoBlock>
